import { getTextContent } from 'helpers';
import { useAnimation } from 'hooks/useAnimation';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectCurrentPostIsLoading } from 'store/slices/BlogSlice';
import Facebook from 'assets/icons/socials/Facebook.svg';
import X from 'assets/icons/socials/X.svg';
import LinkedIn from 'assets/icons/socials/linkedin.svg';
import LinkSimple from 'assets/icons/LinkSimple.svg';
import BlogAPISection from './BlogAPISection';

const PostBody = ({ image, contents }) => {
    const loading = useSelector(selectCurrentPostIsLoading);
    const [linkCopied, setLinkCopied] = useState(false);

    const container = useRef();
    useAnimation({
        items: ['.post-body__main-image', '.post-body p', '.post-body h1', '.post-body h2', '.post-body h3', '.post-body h4', '.post-body h5', '.post-body h6', '.post-body ul', '.post-body ol', '.post-body blockquote'],
        container,
        dependencies: [loading],
    });

    const copyLinkToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setLinkCopied(true);
            setTimeout(() => setLinkCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const renderContent = (contentItem) => {
        switch (contentItem.__component) {
            case 'componetns.rich-editor':
                return <div>{getTextContent(contentItem.content)}</div>;
            case 'componetns.api-integtrations':
                return <BlogAPISection data={contentItem.language} />;
            default:
                console.log(contentItem.__component);
                return null;
        }
    };

    return (
        <div ref={container} className="post-body">
            <img className="post-body__main-image" src={image} alt="" />


            {

                contents?.map((contentItem) => (
                    <div key={contentItem.id}>
                        {renderContent(contentItem)}
                    </div>
                ))}

            <div className='post-body-share'>
                <p className='title body-2'>Was it interesting? Share with others</p>
                <div className='post-body-share-links'>
                    <Link to={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href)} className="footer-media__social-icon" target="_blank" rel="noopener noreferrer">
                        <img src={Facebook}
                            aria-label={"Facebook"}
                            alt={"Facebook"}
                        />
                    </Link>
                    <Link to={"https://twitter.com/intent/tweet?url=" + encodeURIComponent(window.location.href)} className="footer-media__social-icon" target="_blank" rel="noopener noreferrer">
                        <img src={X}
                            aria-label={"Twitter"}
                            alt={"Twitter"}
                        />
                    </Link>
                    <Link to={"https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(window.location.href)} className="footer-media__social-icon" target="_blank" rel="noopener noreferrer">
                        <img src={LinkedIn}
                            aria-label={"LinkedIn"}
                            alt={"LinkedIn"}
                        />
                    </Link>
                    <button className="footer-media__social-icon -share" onClick={copyLinkToClipboard}>
                        <img src={LinkSimple}
                            aria-label={"Copy Link"}
                            alt={"Copy Link"}
                        />
                        <span className='button-text'>{linkCopied ? "Copied!" : "Copy link"}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PostBody;